export const safelyAddQuery = (url: string, query: string): string =>
  url.includes("?") ? `${url}&${query}` : `${url}?${query}`;
